module.exports = __webpack_public_path__ + "static/media/ublogo.d46c4dec.png";